function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import Collector from "../../services/collector";
import Translate from "../common/translation";
import { _Logger } from "../../services/core";
var QuestionService = {
  formatName: function formatName(name, responses, loop, locale, currentQuestion) {
    try {
      var loopName = loop;
      var alias = loop;
      var localeResponse = _objectSpread({}, responses);
      if (loop !== null && loop !== void 0 && loop.name) {
        loopName = loop.name[locale];
        alias = loop.alias;
      }
      if (alias) {
        var newResponses = Collector.getBlocByAlias(responses, alias);
        if (newResponses) {
          localeResponse = newResponses.responses;
        }
      }
      return QuestionService.replaceWordingInText(name, localeResponse, locale, currentQuestion, loopName, alias ? responses : null);
    } catch (e) {
      _Logger.error('QuestionService.formatName', 'fc error', {
        e: e
      });
      return null;
    }
  },
  replaceWordingInText: function replaceWordingInText(name, responses, locale, currentQuestion, loopName, originalResponses) {
    if (!currentQuestion) {
      return name;
    }
    if (name && name.indexOf('{{') !== -1) {
      var startIndex = name.indexOf('{{');
      var endIndex = name.indexOf('}}');
      var reference = name.substr(startIndex, endIndex - startIndex + 2);
      var word = reference.replace('{{', '');
      word = word.replace('}}', '');

      // Découpage
      var firstPart = name.substr(0, startIndex);
      var secondPart = name.substr(endIndex + 2);
      var currentResponse = null;
      var wordParameters = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.publicParameters[word];

      // un mot une réponse
      if (wordParameters) {
        wordParameters = JSON.parse(wordParameters);

        // On récupère la réponse par rapport à l'alias dans les paramètres.
        var linkedQuestion = Collector.getQuestionByAlias(responses, wordParameters.questionAlias);

        // dans le cas d'une boucle, si la question n'est pas trouvé.
        if (!linkedQuestion && originalResponses) {
          linkedQuestion = Collector.getQuestionByAlias(originalResponses, wordParameters.questionAlias);
        }
        if (!linkedQuestion) {
          return name;
        }
        var linkedQuestionResponses = linkedQuestion.responses;
        var linkedQuestionResponsesKeys = Object.keys(linkedQuestionResponses);
        // On découpe en plusieurs morceaux pour traiter tous les mots à remplacer.
        // le premier mot est forcément entre les deux, donc le reste des mots à rempplacer
        // est dans la seconde partie

        // recherche de l'alias de réponse souhaité sinon c'est la 1ere réponse
        if (!wordParameters.response) {
          var _linkedQuestion$quest;
          currentResponse = linkedQuestionResponses[linkedQuestionResponsesKeys[0]];
          currentResponse = typeof currentResponse !== 'boolean' ? currentResponse : linkedQuestionResponsesKeys[0];

          // récupère si possible la traduction depuis la réponse.
          if ((_linkedQuestion$quest = linkedQuestion.questionObj) !== null && _linkedQuestion$quest !== void 0 && _linkedQuestion$quest.expectedResponses) {
            linkedQuestion.questionObj.expectedResponses.forEach(function (exptectedResponse) {
              if (exptectedResponse.alias === currentResponse) {
                currentResponse = exptectedResponse.name[locale];
              }
            });
          }
        } else {
          currentResponse = linkedQuestionResponses[wordParameters.response];
        }
        if (currentResponse instanceof Date) {
          var day = currentResponse.getDate();
          var month = currentResponse.getMonth() + 1;
          var year = currentResponse.getFullYear();
          currentResponse = "".concat(day < 10 ? "0".concat(day) : day, "/").concat(month < 10 ? "0".concat(month) : month, "/").concat(year);
        }
        name = /*#__PURE__*/React.createElement(React.Fragment, null, firstPart, /*#__PURE__*/React.createElement(Translate, {
          id: currentResponse
        }));
      } else if (word === 'loop') {
        name = /*#__PURE__*/React.createElement(React.Fragment, null, firstPart, /*#__PURE__*/React.createElement(Translate, {
          id: loopName
        }));
      }

      // En donnant la seconde partie on permet de remplacer tous les mots souhaités
      var secondComponent = QuestionService.replaceWordingInText(secondPart, responses, locale, currentQuestion, loopName, originalResponses);
      name = /*#__PURE__*/React.createElement(React.Fragment, null, name, secondComponent);
    }
    return name;
  }
};
export default QuestionService;